import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t, i18n } = useTranslation();
  const prefix = i18n.language === 'pt' ? '' : '/' + i18n.language;

  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20colorful%20premium%20sneakers%20arranged%20in%20a%20neat%20grid%20on%20a%20warm%20terracotta%20textured%20background%2C%20editorial%20fashion%20photography%2C%20soft%20directional%20lighting%2C%20bold%20minimal%20composition%2C%20warm%20amber%20and%20cream%20tones&width=1920&height=1080&seq=hero-bg-2&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 gradient-overlay-dark"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-24 md:pt-28 pb-16 md:pb-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-background-50 leading-tight mb-6 md:mb-8">
            {t('hero.title')}
          </h1>
          <p className="text-base md:text-lg lg:text-xl text-background-200/90 leading-relaxed max-w-3xl mx-auto mb-8 md:mb-10">
            {t('hero.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-primary text-base px-8 py-3.5 w-full sm:w-auto"
            >
              <i className="ri-file-list-3-line mr-2"></i>
              {t('hero.ctaSpreadsheet')}
            </a>
            <a
              href={prefix + '/cssbuy-spreadsheet'}
              className="btn-secondary text-base px-8 py-3.5 border-background-300 text-background-50 hover:bg-white/10 hover:text-background-50 w-full sm:w-auto"
            >
              <i className="ri-book-open-line mr-2"></i>
              {t('hero.ctaGuides')}
            </a>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center text-sm text-background-200/80 hover:text-background-50 transition-colors underline underline-offset-4"
            >
              <i className="ri-external-link-line mr-1.5"></i>
              {t('hero.ctaMain')}
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-background-200/60"></i>
      </div>
    </section>
  );
}